/**
 * Alert API client. Reads the alerts table; the Worker shapes the JSON
 * `data` blob into a uniform { title, detail, symbol } projection.
 *
 *   GET /api/alerts — most recent system + breach alerts
 */

import type { AlertRow } from "@pfh/shared";
import { api } from "../api";

export type { AlertRow } from "@pfh/shared";

export async function listAlerts(): Promise<AlertRow[]> {
  const res = await api.get<{ alerts: AlertRow[] }>("/api/alerts");
  return res.alerts;
}
